module.exports = __webpack_public_path__ + "static/media/bg_squid_game.74051c00.mp3";